// @react/hooks/useBillingInvoice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingInvoiceStore } from '@core/stores';

/**
 * React hook for Invoice operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingInvoice } from '@react/hooks';
 *
 * const InvoiceList = observer(() => {
 *   const store = useBillingInvoice();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingInvoice() {
  return billingInvoiceStore;
}
